export const FETCH_ANALYSIS_TYPE_CODE = 'code.FETCH_ANALYSIS_TYPE_CODE';

